import {AREA_OPTIONS} from "@/utils/constants";

export const groupRosterPlayers = (members = []) => {
	const groups = {};
	AREA_OPTIONS.forEach((role) => {
		const matching = members.filter(
			(member) =>
				(member.player?.goalkeeper && role.value === "Goalkeeper") ||
				member.player?.primaryRole === role.label,
		);
		if (matching.length) groups[role.groupLabel] = matching;
	});
	const withoutRole = members.filter(
		(member) =>
			!member.player?.goalkeeper &&
			!AREA_OPTIONS.some((role) => member.player?.primaryRole === role.label),
	);
	if (withoutRole.length) groups["Ruolo non definito"] = withoutRole;
	return groups;
};
